/**
 * Formatage d'entiers d'affichage (compteurs, pagination) — BL-0399.
 */

/**
 * Formate un entier selon la locale i18n (FR : espace millier ; EN : virgule).
 */
export function u2000FormatIntegerCount(value: number, locale: string): string {
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(value);
}
